import { FC, useState } from 'react'
import styled from 'styled-components'
import Button from '@app.components/Button'
import PictureOffIcon from 'svgIcons/PictureOff'
import TagIcon from 'svgIcons/Tag'
import ModalRecommendTags from './ModalRecommendTags'

interface NewsEditorActionsProps {
  fileUploadDialogId: string
  pictureButtonDisabled?: boolean
  onApplyTags: (tags: string[]) => void
  className?: string
}

const NewsEditorActions: FC<NewsEditorActionsProps> = ({
  fileUploadDialogId,
  pictureButtonDisabled = false,
  onApplyTags,
  className,
}) => {
  const [modalVisible, setModalVisible] = useState(false)

  return (
    <>
      <StyledWrapper className={className}>
        <Button
          id={`uppy-file-upload-trigger-${fileUploadDialogId}`}
          disabled={pictureButtonDisabled}
          color="grey"
          variant="outlined"
          className="button"
        >
          <PictureOffIcon className="picture-icon" />
          사진
        </Button>
        <Button
          onClick={() => setModalVisible(true)}
          variant="outlined"
          className="button"
        >
          <TagIcon />
          추천태그
        </Button>
      </StyledWrapper>
      {modalVisible && (
        <ModalRecommendTags
          onClose={() => setModalVisible(false)}
          onApply={onApplyTags}
        />
      )}
    </>
  )
}

export default NewsEditorActions

const StyledWrapper = styled.div`
  .button {
    height: 46px;
    color: #333;
    padding: 0 15px;
  }

  & .picture-icon {
    & g:nth-of-type(1) {
      stroke: #555;
    }
    & g:nth-of-type(2) {
      fill: #555;
    }
  }

  & > *:nth-child(n + 2) {
    margin-left: 8px;
  }
`
